/**Deprecated */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import classNames from "classnames";

import GatsbyImageWithSVGSupport from "./GatsbyImageWithSVGSupport";
import RichTextBlock from "./RichTextBlock";
import EmbeddedFrame from "./EmbeddedFrame";

const MediaFrames = ({ mediaFiles }) => {
    if (!mediaFiles?.length) return null;

    if (mediaFiles.length > 1) {
        return (
            <Carousel fade className="mb-3 mb-md-0">
                {mediaFiles.map(media => (
                    <Carousel.Item key={media.file.url}>
                        {media.mimeType === "video/mp4" ? (
                            <video
                                className="mw-100 round-frame video"
                                controls
                                preload="none"
                            >
                                <source
                                    src={media.file.url}
                                    type={media.mimeType}
                                />
                                <track
                                    src={media.file.url}
                                    kind="captions"
                                    srcLang="en"
                                    label="english_captions"
                                ></track>
                                {console.log()}
                            </video>
                        ) : (
                            <GatsbyImageWithSVGSupport
                                className="image mw-100"
                                image={media}
                            />
                        )}
                    </Carousel.Item>
                ))}
            </Carousel>
        );
    }

    if (mediaFiles[0].mimeType === "video/mp4") {
        return (
            <video
                preload="none"
                poster={mediaFiles[0].fields.thumbnail.publicURL}
                className="mw-100 round-frame video"
                controls
            >
                <source
                    src={mediaFiles[0].file.url}
                    type={mediaFiles[0].mimeType}
                />
                <track
                    src={mediaFiles[0].file.url}
                    kind="captions"
                    srcLang="en"
                    label="english_captions"
                ></track>
            </video>
        );
    }

    return <GatsbyImageWithSVGSupport image={mediaFiles[0]} />;
};

MediaFrames.propTypes = {
    mediaFiles: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            description: PropTypes.string,
            mimeType: PropTypes.string,
            gatsbyImageData: PropTypes.object,
            file: PropTypes.shape({
                contentType: PropTypes.string.isRequired,
                url: PropTypes.string.isRequired,
            }),
        }),
    ),
};

const ZigZagRow = ({ row }) => {
    const ref = useRef(null);
    const [hasAnimated, setHasAnimated] = useState(false);
    const [animateImage, setAnimateImage] = useState(false);

    useEffect(() => {
        const element = ref.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !hasAnimated) {
                    setHasAnimated(true);
                    observer.disconnect(); // Stop observing after animation is triggered
                }
            },
            { threshold: 0.2 },
        );

        if (element) {
            observer.observe(element);
        }

        if (hasAnimated) {
            setTimeout(() => setAnimateImage(true), 400);
        }

        // Cleanup function using the captured local variable
        return () => {
            if (element) {
                observer.unobserve(element);
            }
        };
    }, [hasAnimated]);

    const getNumCol = row =>
        12 /
        ((row.copy ? 1 : 0) +
            (row.mediaFiles?.length || row.embeddedMediaUrl ? 1 : 0));

    const component = (
        <Row
            ref={ref}
            className={classNames(row.className, {
                "justify-content-center":
                    row.embeddedMediaUrl || row.type === "Video",
            })}
        >
            {(row.mediaFiles || row.embeddedMediaUrl) && (
                <Col
                    md={getNumCol(row)}
                    className={classNames(
                        "d-flex justify-content-center align-items-center mb-4 mb-md-0",
                        {
                            "order-md-2": row.leftContent !== "Media",
                            "fade-in-up": animateImage,
                            "ps-0":
                                row.fullBleedMedia &&
                                row.leftContent === "Media",
                            "pe-0":
                                row.fullBleedMedia &&
                                row.leftContent !== "Media",
                        },
                    )}
                >
                    {row.embeddedMediaUrl ? (
                        <EmbeddedFrame
                            embeddedMediaUrl={row.embeddedMediaUrl}
                        />
                    ) : (
                        <MediaFrames mediaFiles={row.mediaFiles} />
                    )}
                </Col>
            )}
            {row.copy && (
                <Col
                    md={getNumCol(row)}
                    className={classNames("my-auto", {
                        "order-md-1 pe-md-5": row.leftContent !== "Media",
                        "fade-in-up": hasAnimated,
                        "zz-copy": row.fullBleedMedia,
                    })}
                >
                    <RichTextBlock content={row.copy} />
                </Col>
            )}
        </Row>
    );

    if (row.fullBleedMedia) return component;

    return <Container>{component}</Container>;
};

ZigZagRow.propTypes = {
    row: PropTypes.shape({
        id: PropTypes.string.isRequired,
        copy: PropTypes.shape({
            raw: PropTypes.string,
            references: PropTypes.array,
        }),
        mediaFiles: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string,
                description: PropTypes.string,
                mimeType: PropTypes.string,
                gatsbyImageData: PropTypes.object,
                file: PropTypes.shape({
                    contentType: PropTypes.string.isRequired,
                    url: PropTypes.string.isRequired,
                }),
            }),
        ),
        embeddedMediaUrl: PropTypes.string,
        leftContent: PropTypes.string,
        className: PropTypes.string,
        fullBleedMedia: PropTypes.bool,
    }),
};

export default ZigZagRow;
